import { Breakpoint, Grid, Theme, useMediaQuery } from '@mui/material';

interface Props {
    CenterContent: React.ReactNode;
    LeftContent: React.ReactNode;
    RightContent: React.ReactNode;
    gap?: number;
    spacing?: number;
    flipBreakpoint?: Breakpoint;
}

const XS_SIZE = 12;
const SM_SIZE = 6;
const MD_SIZE = 4;

export function TripleColumnLayout({
    LeftContent,
    CenterContent,
    RightContent,
    gap = 2,
    spacing = 2,
    flipBreakpoint = 'sm',
}: Props) {
    const smDown = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down(flipBreakpoint)
    );
    const FirstContent = smDown ? CenterContent : LeftContent;
    const SecondContent = smDown ? LeftContent : CenterContent;

    return (
        <Grid container direction="row" spacing={spacing}>
            <Grid
                container
                direction="column"
                gap={gap}
                size={{
                    xs: XS_SIZE,
                    sm: SM_SIZE,
                    md: MD_SIZE,
                }}
            >
                {FirstContent}
            </Grid>
            <Grid
                container
                direction="column"
                gap={gap}
                size={{
                    xs: XS_SIZE,
                    sm: SM_SIZE,
                    md: MD_SIZE,
                }}
            >
                {SecondContent}
            </Grid>
            <Grid
                container
                direction="column"
                gap={gap}
                size={{
                    md: MD_SIZE,
                    sm: SM_SIZE,
                    xs: XS_SIZE,
                }}
            >
                {RightContent}
            </Grid>
        </Grid>
    );
}
